import { Link, useLocation } from 'react-router-dom';

const TABS: Array<{ to: string; label: string; match: (p: string) => boolean }> = [
  { to: '/billing', label: 'Übersicht', match: (p) => p === '/billing' },
  { to: '/billing/statements', label: 'Abrechnungen', match: (p) => p.startsWith('/billing/statements') },
  { to: '/billing/price-lists', label: 'Preislisten', match: (p) => p.startsWith('/billing/price-lists') },
];

/** Sub-Navigation des Abrechnungsbereichs (Übersicht · Abrechnungen · Preislisten). */
export function BillingTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="flex gap-1 border-b mb-4" aria-label="Abrechnung">
      {TABS.map((t) => {
        const active = t.match(pathname);
        return (
          <Link
            key={t.to}
            to={t.to}
            className={`px-3 py-2 text-sm border-b-2 -mb-px ${active ? 'border-neutral-900 font-semibold text-neutral-900' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
            aria-current={active ? 'page' : undefined}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
